import { ITrackingId } from './meeting-types.model';

export interface IMeetingDirectory {
    directoryId: string;
    userId: string;
    directoryName: string;
    title?: string;
    meetingTypes: IDirectoryMeetingType[];
    code: string;
    isDefault?: boolean;
    instructions?: string;
    locked?: boolean;
    googleTrackingIds?: ITrackingId[];
}

interface IDirectoryMeetingType {
    userId: string;
    name: string;
}
